function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.5056 17.2585V11.7434C11.5056 11.322 11.8485 10.9792 12.2699 10.9792C12.6914 10.9792 13.0342 11.322 13.0342 11.7434H14.7733C14.7733 10.363 13.6503 9.23999 12.2699 9.23999C10.8894 9.23999 9.76652 10.3631 9.76652 11.7434V17.2585H6.66699V19.7118H33.3337V17.2585H11.5056V17.2585Z",
  fill: "#D7D6E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.9707 21.4504V21.8287V24.7691C7.9707 26.8181 9.5168 28.5118 11.5035 28.7476L10.9986 30.1847L12.6395 30.7611L13.3366 28.7767H26.6637L27.3608 30.7611L29.0017 30.1847L28.4969 28.7476C30.4836 28.5118 32.0296 26.818 32.0296 24.7691V21.8287V21.4504H7.9707Z",
  fill: "#D7D6E0"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 26.6667,
  height: 26.6667,
  fill: "white",
  transform: "translate(6.66699 6.66675)"
})));

var SvgBath = function SvgBath(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBath, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bath.aa9780b6.svg";
export { ForwardRef as ReactComponent };